import React, { useState } from 'react';
import style from '../content-list.module.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { AddCardChoice } from './AddCardChoice';
import { CardChoice } from './CardChoice';
import { CardChoice as TCardChoice } from '../../types';
import { usePermissions } from '../../../../hooks';

type Props = {
	scrollRef:any|null;
	contents: (TCardChoice & { id: string; updatedAt: string|null; createdAt: string })[];
	refetchContent: () => void;
	isAutocomplete?: boolean;
	hasMore:boolean;
	loadMore: () => void;
};

// CardChoiceList will be treated as 'AutocompleteList' 
// based on the 'isAutocomplete' boolean flag.
// This is done since both these components are very similar with
// minor changes in schema and UI
export function CardChoiceList(props: Props) {
	const { scrollRef, contents: cardChoices, hasMore, refetchContent, loadMore, isAutocomplete = false } = props;

	return (
		<div className={style.contentList}>
			<Header {...props} />
			<div className={style.selector}>
				<div>
					<p>{isAutocomplete ? 'Autocomplete' : 'Card Choice'}</p>
				</div>
				<p>Updated At</p>
				<p>Created At</p>
			</div>
			<div id="infiniteScrollTarget" ref={scrollRef} className={style.textList} style={{overflow: "auto", height: "calc(100vh - 200px)"}}>
				{cardChoices.length>0?
					<InfiniteScroll
						dataLength={cardChoices.length}
						next={loadMore}
						hasMore={hasMore}
						scrollableTarget="infiniteScrollTarget"
						loader={<div className={style.loadingContainer}>Loading...</div>}>
						{cardChoices.map((el) => (
							<CardChoice isAutocomplete={isAutocomplete} key={el.id} cardChoice={el} refetchContent={refetchContent} />
						))}
					</InfiniteScroll>
				:
					null
				}
			</div>
		</div>
	);
}

function Header(props: Props) {
	const { isAutocomplete = false } = props
	const [isOpen, setIsOpen] = useState(false);
	const canCreate = usePermissions('content.Create')
	return (
		<div className={style.header}>
			{canCreate &&
				<button className={style.add} onClick={() => setIsOpen(true)}>
					<img src={AddIcon} alt="add" />
					<span>Add {isAutocomplete ? 'Autocomplete' : 'Card Choice'}</span>
				</button>
			}
			{isOpen && (
				<AddCardChoice
					isAutocomplete={isAutocomplete}
					isOpen={isOpen}
					close={() => setIsOpen(false)}
					refetchContent={props.refetchContent}
				/>
			)}
		</div>
	);
}
